module.exports = __webpack_public_path__ + "ac31367cd040059b4ba657b220a18542.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/8_G2.mp3
// module id = 124
// module chunks = 0